
import { Toast } from "vant";
import { Component, Vue } from "vue-property-decorator";
import { bypassword } from "@/req/login";
import { validatebyd } from "./validateLogin.js";
import NavBar from "./header.vue";
import slideVerify from "./slideVerify.vue";
@Component({
  components: {
    NavBar,
    slideVerify,
  },
})
export default class Logout extends Vue {
  // 表单效验规则
  public loginFormRules = {
    username: [{ required: true }],
    password: [{ required: true }],
  };
  public loginShow = 0;
  public ncSceneId = 0;
  public passwordShow = false;
  public passwordImgShow = require(`@/assets/img/login/password.png`);
  public passwordImgHide = require(`@/assets/img/login/password-close.png`);
  public isLoading = false;
  public imgRotate = false;
  public btnBgc = false;
  public flag = true;
  public accord = "";
  public products: any = [];
  public formLogin: any = {
    username: "",
    password: "",
    clause: true,
  };
  public mounted() {
    if (
      this.$fn.cookies.getToken("token") === "" ||
      this.$fn.cookies.getToken("token") === null
    ) {
      this.savePassword();
    }
  }
  public focus() {
    this.upKeyboard();
  }

  public upKeyboard() {
    if (!this.flag) return;
    const $login = this.$refs.login as any;
    $login.style.height = $login.offsetHeight + "px";
    this.flag = false;
  }
  // 账号密码渲染
  public savePassword() {
    if (
      localStorage.getItem("temp") !== null &&
      localStorage.getItem("temp") !== undefined
    ) {
      const tempObj = (JSON.parse as any)(localStorage.getItem("temp"));
      this.products = JSON.parse(JSON.stringify(tempObj));
      this.formLogin.username = tempObj[0].username;
    }
  }
  // 登录
  public async onSubmit() {
    const validate: any = validatebyd(this.formLogin.clause, this.formLogin);
    if (validate) return Toast(validate);
    this.loginShow = 1;
  }
  public async getParam($event) {
    const param = $event;
    Toast.loading({
      message: "登录中，请稍后",
      forbidClick: true,
      loadingType: "spinner",
      duration: 0,
    });
    let objData: any = {
      username: this.formLogin.username,
      password: this.formLogin.password,
    };
    objData = { ...objData, ...param };
    const res = await bypassword(objData);
    if (res.code != 200) this.loginShow = 0;
    if (res.code === 200) {
      this.$fn.cookies.setToken(res.data.token);
      const arrList = [];
      const savePass = {
        username: this.formLogin.username,
      };
      if (localStorage.getItem("temp") != null) {
        const tempObj = (JSON.parse as any)(localStorage.getItem("temp")); // localstorage转换
        tempObj.unshift(savePass);
        let len = tempObj.length;
        for (let i = 0; i < len; i++) {
          for (let j = i + 1; j < len; j++) {
            if (tempObj[i].username === tempObj[j].username) {
              tempObj.splice(j, 1);
              j--; // 每删除一个数j的值就减1
              len--; // j值减小时len也要相应减1（减少循环次数，节省性能）
            }
          }
        }
        const saveObj = JSON.stringify(tempObj); // 数组转换存储
        localStorage.setItem("temp", saveObj);
      } else {
        (arrList as any).unshift(savePass);
        const saveObj = JSON.stringify(arrList);
        localStorage.setItem("temp", saveObj);
      }
      // 自动登录状态判断
      const loginPass = {
        accord: this.accord,
      };
      const loginObj = JSON.stringify(loginPass);
      localStorage.setItem("tempLogin", loginObj);
      Toast.clear();
      this.$router.push({ name: "my" });
    } else if (res.code == 20015) {
      Toast.clear();
      this.$router.push({ name: "bindPhone", params: { objData } });
    } else if (res.code == 20041) {
      Toast("账号首字符必须为字母");
    } else if (res.code == 20045) {
      Toast.clear();
      this.loginShow = 1;
    } else {
      Toast(res.msg);
    }
  }
  // 切换账号
  public changeLogin(index) {
    this.products.map((item, ids) => {
      if (index === ids) {
        this.formLogin.username = JSON.parse(JSON.stringify(item.username));
        // this.formLogin.clause = true;
      }
    });
    this.imgRotate = false;
  }
  public onChange() {
    if (this.formLogin.password === "" || this.formLogin.username === "") {
      this.btnBgc = false;
    } else {
      this.btnBgc = true;
    }
  }
  // 删除历史账号
  public del(id) {
    const uname = this.products[id].username;
    const tempObj = (JSON.parse as any)(localStorage.getItem("temp"));
    this.products = JSON.parse(JSON.stringify(tempObj));
    this.products.some((item, index) => {
      if (item.username === uname) {
        this.products.splice(index, 1);
      }
    });
    const loginObj = JSON.stringify(this.products);
    localStorage.setItem("temp", loginObj);
    if (localStorage.getItem("temp") === "[]") {
      localStorage.removeItem("temp");
    }
  }
  public onRegister() {
    this.$router.push({
      name: "registration",
    });
  }
  public onGoBack() {
    this.loginShow = 0;
  }
  public getUrl(val) {
    let url: any = "";
    if (!(val === "serve")) {
      url = "http://land.996box.com/Privacy-policy.html";
    } else {
      url = "http://land.996box.com/user-agreement.html";
    }
    window.open(url);
  }

  // 取消选择账号
  public onCancel() {
    if (!this.imgRotate) return;
    this.imgRotate = false;
  }
}
